import type { QueryClient } from "@tanstack/react-query";
import type { Role, SessionUser } from "@contractorhub/shared";
import { UnauthorizedError } from "./api";
import { meQuery } from "./queries";

/** The signed-in user, or null when the session cookie is missing/expired. */
export async function fetchUser(queryClient: QueryClient): Promise<SessionUser | null> {
  try {
    const { user } = await queryClient.ensureQueryData(meQuery);
    return user;
  } catch (err) {
    if (err instanceof UnauthorizedError) return null;
    throw err;
  }
}

/**
 * Where each role lands: its own dashboard. The path is shared and the page
 * switches on the role (`routes/_authed/dashboard.tsx`), so a link to "home"
 * never has to know who is following it. `role` stays a parameter so the
 * guards keep saying whose home they are sending someone to.
 */
export function homeFor(_role: Role): "/dashboard" {
  return "/dashboard";
}
